import { Component, input, computed, inject, effect } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { SupportNumberService } from '../../common/help-menu';
import { getImageSrc } from '../../core/images';
import { HelpCase, HelpCaseId } from './help-center-cases';

@Component({
  selector: 'app-help-case-card',
  templateUrl: './help-case-card.component.html',
  styleUrls: ['./help-case-card.component.scss'],
  standalone: false,
})
export class HelpCaseCardComponent {
  readonly supportNumberService = inject(SupportNumberService);

  helpCase = input.required<HelpCase>();
  hasMeetingUrl = input<string>('');
  hideStyle = input.required<boolean>();

  getImageSrc = getImageSrc;
  countryCode = 'US';

  phone: string | undefined;

  showCard = computed(() => {
    return (
      this.helpCase().id !== HelpCaseId.BOOK_MEETING ||
      (this.helpCase().id === HelpCaseId.BOOK_MEETING && !!this.hasMeetingUrl())
    );
  });

  constructor() {
    effect(async () => {
      this.phone =
        this.helpCase()?.id === HelpCaseId.CALL_US
          ? await firstValueFrom(this.supportNumberService.getSupportNumber())
          : undefined;
    });
  }
}
